const LISTE_DEMANDE = {
  title: 'Gestion des demandes',
  breadcrumb: {
    liste: 'Gestion des demandes',
    racine: 'Accueil',
  },
  actions: {
    search: 'Rechercher',
    simulation: 'Vérification automatique',
  },
  card: {
    week: 'Semaine',
    payeur: 'Payeur(s)',
    annonceur: 'Annonceur(s)',
    face: 'Faces :',
    commercial: 'Commercial',
    anneeSemaine: 'S{week}',
    noDefine: 'Non défini',
    etatSouhaite: 'Etat souhaité :',
    etatObtenu: 'Etat actuel :',
    rang: 'Rang :',
    etatObtenuForce: 'Etat obtenu :',
    prixNet: 'Prix de vente :',
    prixNetFace: 'Prix net / face : ',
    objectif: 'Objectif face',
    agence: 'Agence :',
    agenceProduit: 'Agence(s) produit(s)',
  },
  messages: {
    errors: {
      noResult: 'Aucune demande en attente',
      etatObtenuDiff: 'Attention, il existe une différence entre l\'état obtenu que vous avez sélectionné et celui à l\'enregistrement',
    },
    info: {
      nbDemande: '{nb} demande(s) en attente(s)',
    },
    success: {
      modifEtatObtenu: 'Le(s) état(s) obtenu(s) ont été modifié(s) avec succès',
    },
  },
};

export default LISTE_DEMANDE;
